import React from 'react';
import { Row, Col } from 'react-bootstrap';
import classes from './index.module.scss';

const CheckBoxContainer = ({ list, register }) => {
  return (
    <div className={classes.Check_Box_Container}>
      <Row>
        {list.map(item => {
          return (
            <Col lg={4} className="mb-4" key={item.id}>
              <div className="Checkbox_Wrap">
                <input
                  type="checkbox"
                  name={item.name}
                  id={item.id} 
                  ref={register()}
                  value={item.id}
                />
                <label htmlFor={item.id}>{item.label}</label>
              </div>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}

export default CheckBoxContainer;